import Vue from 'vue';
import BaseFilter from './readableidsfilter';
import axios from 'axios';
import qs from 'qs';
import debounce from 'debounce';

export default Vue.component('servicepointsfilter', {
    extends: BaseFilter,
    data(){
        return {
            backofficeService: axios.create({
                baseURL: '/mywecycle/backoffice',
                paramsSerializer: function(params) {
                    return qs.stringify(params, { indices: false, allowDots: true, skipNulls: true })
                }
            })
        }
    },
    methods:{
        getFilterData: debounce(function (event) {
            var code = event.target.value !== null ? `${this.prefix}${event.target.value}` : '';

            this.backofficeService.get('getservicepoint', {
                    params: { servicePointCode: code }
                }).then((response) => { 
                    /** todo : normalize the service on webapi controller */
                    this.$emit('input', response.data.ServicePointId);
                    this.$emit('update:text', event.target.value);
                    this.$emit('update:description', response.data.ServicePointName);
                }).catch((thrown) => {
                    console.log('app error', thrown.message);
                });
          }, 300)
    }
});